import React from "react";
import Image from "next/image";
import pagingImg from "../../public/images/news/paging-arrow.png";

const Pagination = (props) => {
  const { whereClause, setWhereClause, totalRecord } = props;
  const currentPage = whereClause.offset / whereClause.limit + 1;
  const totalPage = Math.ceil(totalRecord / whereClause.limit);
  const buttonPaging = [];

  const handlePaging = (page) => {
    if (currentPage === page || page < 0 || page > totalPage) {
      return;
    }
    setWhereClause({ ...whereClause, offset: (page - 1) * whereClause.limit });
  };

  for (let index = 1; index <= totalPage; index++) {
    buttonPaging.push(
      <li
        className={`page-item ${
          index === currentPage ? "active disabled" : ""
        }`}
        key={index}
      >
        <a className="page-link" href="#" onClick={() => handlePaging(index)}>
          {index}
        </a>
      </li>
    );
  }

  return (
    <div className="pagination-container">
      <li
        className={` ${currentPage === 1 ? "disabled" : ""}`}
        onClick={() => handlePaging(currentPage - 1)}
      >
        <a className="page-link" href="#">
          <div className="prev-page">
            <Image
              className="previous-arrow"
              src={pagingImg}
              alt={"previous arrow"}
              width={30}
              height={20}
            />
            <p className="ml--10">Previous</p>
          </div>
        </a>
      </li>
      <li>
        <div className="paging-list">{buttonPaging}</div>
      </li>

      <li
        className={` ${currentPage === totalPage ? "disabled" : ""}`}
        onClick={() => handlePaging(currentPage + 1)}
      >
        <a className="page-link" href="#">
          <div className="next-page">
            <p className="mr--10">Next</p>
            <Image
              className="next-arrow"
              src={pagingImg}
              alt={"next arrow"}
              width={40}
            />
          </div>
        </a>
      </li>
    </div>
  );
};

export default Pagination;
